import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const METRICS = [
  { key: "ten_yard", label: "10-Yard", invert: true },
  { key: "flying_ten", label: "Flying 10", invert: true },
  { key: "vertical", label: "Vertical", invert: false },
  { key: "broad", label: "Broad Jump", invert: false },
  { key: "speed_score", label: "Speed Score", invert: false },
  { key: "power_score", label: "Power Score", invert: false },
];

export default function ProgressCharts({ records }) {
  if (!records || records.length < 1) {
    return <div className="text-white/40 text-sm border border-white/10 bg-[#121212] p-6" data-testid="progress-empty">No test data yet. Your progress graphs appear after your first evaluation.</div>;
  }
  const data = records.map((r) => ({
    date: new Date(r.date).toLocaleDateString(undefined, { month: "short", day: "numeric" }),
    ten_yard: r.ten_yard, flying_ten: r.flying_ten, vertical: r.vertical, broad: r.broad,
    speed_score: r.speed_score, power_score: r.power_score,
  }));

  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid="progress-charts">
      {METRICS.map((m) => {
        const has = data.some((d) => d[m.key] != null);
        if (!has) return null;
        return (
          <div key={m.key} className="bg-[#121212] border border-white/10 p-4">
            <p className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40 mb-3">{m.label}{m.invert ? " (lower is better)" : ""}</p>
            <div style={{ width: "100%", height: 140 }}>
              <ResponsiveContainer>
                <LineChart data={data} margin={{ top: 5, right: 8, left: -20, bottom: 0 }}>
                  <CartesianGrid stroke="#ffffff10" vertical={false} />
                  <XAxis dataKey="date" tick={{ fill: "#ffffff55", fontSize: 10 }} axisLine={{ stroke: "#ffffff20" }} tickLine={false} />
                  <YAxis tick={{ fill: "#ffffff55", fontSize: 10 }} axisLine={false} tickLine={false} domain={["auto", "auto"]} reversed={m.invert} />
                  <Tooltip contentStyle={{ background: "#000", border: "1px solid #ffffff20", fontSize: 12 }} labelStyle={{ color: "#fff" }} />
                  <Line type="monotone" dataKey={m.key} stroke="#ffffff" strokeWidth={2} dot={{ r: 3, fill: "#fff" }} connectNulls />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        );
      })}
    </div>
  );
}
